import { render, staticRenderFns } from "./MenuTable.vue?vue&type=template&id=4ec19384"
import script from "./MenuTable.vue?vue&type=script&lang=js"
export * from "./MenuTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports